module.exports = __webpack_public_path__ + "static/media/1.8d4d3fc1.svg";